export default __webpack_public_path__ + "static/media/mp4.2710efdd.svg";